import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { ExperimentService } from '@services/experiment/experiment.service';

export const npsFeedbackRevampGuard: CanMatchFn = async () => {
  const experimentService = inject(ExperimentService);
  await experimentService.experimentsLoaded;
  return experimentService.isNpsFeedbackRevampEnabled();
};
